import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Acknowledgment({ userData, onComplete }) {
  const [ack,setAck]=useState(null), [agreed,setAgreed]=useState(false), [signatureName,setSignatureName]=useState('');
  const [error,setError]=useState(''), [submitting,setSubmitting]=useState(false);
  useEffect(()=>{ let active=true; axios.get('/api/acknowledgment').then(({data})=>active&&setAck(data)).catch(()=>active&&setError('The acknowledgment could not be loaded. Refresh and try again.')); return()=>{active=false;}; },[]);
  const normalize=v=>v.normalize('NFKC').trim().replace(/\s+/g,' ').toLocaleLowerCase('en-US');
  async function sign(event) {
    event.preventDefault();setError('');
    if (!agreed || normalize(signatureName)!==normalize(userData.fullName)) { setError('Confirm the acknowledgment and type your full name as shown.'); return; }
    setSubmitting(true);
    try {
      await axios.post('/api/completions',{acknowledgmentAccepted:true,acknowledgmentVersion:ack.version,signatureName},{headers:{'x-training-request':'1'},withCredentials:true});
      await onComplete();
    } catch(e) {setError(e.response?.data?.error || 'Your request could not be completed. You can safely try again.');}
    finally {setSubmitting(false);}
  }
  return <div className="page-container">
    <div className="step-badge">Step 4 of 5 · Acknowledgment</div>
    <h1 className="page-title">One last step: your signature.</h1>
    <p className="page-subtitle">Your quiz is passed. Read the acknowledgment below, then sign to receive your certificate.</p>
    <div className="card">
      {error&&<p className="error-banner" role="alert">{error}</p>}
      {!ack?<p role="status">Loading acknowledgment…</p>:<form onSubmit={sign}>
        {ack.paragraphs.map((p,i)=><p className="spaced" key={i}>{p}</p>)}
        <p className="form-hint">Acknowledgment version: {ack.version}</p>
        <label className="ack-consent"><input type="checkbox" required checked={agreed} onChange={e=>setAgreed(e.target.checked)}/><span>I have read and accept this acknowledgment.</span></label>
        <div className="form-group"><label className="form-label" htmlFor="signatureName">Type your full name to sign</label>
        <input id="signatureName" className="form-input signature-input" required maxLength={200} autoComplete="name" value={signatureName} onChange={e=>setSignatureName(e.target.value)} aria-describedby="signature-hint"/>
        <p id="signature-hint" className="form-hint">Name on your record: {userData.fullName}. Your electronic signature and signing time will be saved with this acknowledgment.</p></div>
        <button className="btn btn-primary btn--full spaced" disabled={submitting||!agreed||!signatureName.trim()}>{submitting?'Saving your completion…':'Sign and complete training'}</button>
      </form>}
    </div>
  </div>;
}
